// /app/instalar y /app-instalar — GUÍA DE INSTALACIÓN (siempre guía,
// nunca "Abrir app"): pestañas Android | iPhone con detección automática,
// ilustraciones SVG propias por paso (assets/instalar/Sketches.jsx —
// estilo bosquejo con tokens del handoff, componente PhoneSketch).
// En standalone redirige a /app (la guía no tiene sentido dentro de la app).
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import appIcon from '../assets/app-icon.svg';
import { EELogo } from '../../components/EEBrand';
import { Android1, Android2, Android3, Iphone1, Iphone2, Iphone3 } from '../assets/instalar/Sketches';
import '../tokens.css';

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandaloneNow = () =>
  (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
  window.navigator.standalone === true;

const Paso = ({ n, sketch, children }) => (
  <div style={{ marginBottom: 20 }}>
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
      <div style={{
        width: 26, height: 26, borderRadius: 9, background: 'var(--ink)', color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, flex: 'none',
      }}>{n}</div>
      <p style={{ fontSize: 14.5, lineHeight: 1.5, margin: 0 }}>{children}</p>
    </div>
    {sketch && (
      <div style={{ maxWidth: 280, margin: '12px auto 0', borderRadius: 16, boxShadow: '0 6px 18px rgba(0,0,0,.10)' }}>
        {sketch}
      </div>
    )}
  </div>
);

export default function Instalar() {
  const [tab, setTab] = useState(isIOS() ? 'iphone' : 'android');
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    // Limpieza del flag legacy "instalada" (estado eliminado por decisión
    // de Matías: esta página es SIEMPRE una guía).
    try { localStorage.removeItem('ee-app-installed'); } catch (_e) { /* noop */ }
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  if (isStandaloneNow()) return <Navigate to="/app" replace />;

  return (
    <div className="app-root">
      <div className="app-scroll" style={{ maxWidth: 480 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 'calc(34px + env(safe-area-inset-top)) 0 18px' }}>
          <img src={appIcon} alt="" style={{ width: 82, height: 82, borderRadius: '23%', marginBottom: 18 }} />
          <span style={{ color: 'var(--ink)' }}><EELogo size={26} /></span>
        </div>
        <div className="app-pgh" style={{ textAlign: 'center' }}>
          <h1>Instala Edge Elite en tu teléfono</h1>
          <p>Acceso directo desde tu pantalla de inicio, a pantalla completa y con alertas. Sin tiendas: toma menos de un minuto.</p>
        </div>

        <div className="app-chips" style={{ justifyContent: 'center', paddingTop: 8 }}>
          <button className={`chip-app${tab === 'android' ? ' on' : ''}`} onClick={() => setTab('android')}>Android</button>
          <button className={`chip-app${tab === 'iphone' ? ' on' : ''}`} onClick={() => setTab('iphone')}>iPhone</button>
        </div>

        {tab === 'android' ? (
          <div className="app-sig" style={{ cursor: 'default', paddingTop: 18 }}>
            {prompt && (
              <button
                onClick={async () => { prompt.prompt(); await prompt.userChoice; setPrompt(null); }}
                style={{ display: 'block', width: '100%', marginBottom: 18, background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 15, padding: 16, fontSize: 16, fontWeight: 700 }}
              >
                Instalar ahora
              </button>
            )}
            <Paso n="1" sketch={<Android1 />}>Toca el menú <strong>⋮ de Chrome</strong> (arriba a la derecha).</Paso>
            <Paso n="2" sketch={<Android2 />}>Elige <strong>“Instalar app”</strong> y confirma.</Paso>
            <Paso n="3" sketch={<Android3 />}>Listo: abre <strong>Edge Elite</strong> desde tu pantalla de inicio.</Paso>
            {!prompt && (
              <p style={{ fontSize: 12.5, color: 'var(--muted)', margin: '4px 0 0', lineHeight: 1.5 }}>
                ¿Ya la tenías instalada antes? Desinstala la versión anterior desde tu pantalla de inicio y repite estos pasos.
              </p>
            )}
          </div>
        ) : (
          <div className="app-sig" style={{ cursor: 'default', paddingTop: 18 }}>
            <Paso n="1" sketch={<Iphone1 />}>Abre <strong>edgeelite.cl</strong> en <strong>Safari</strong> y toca <strong>Compartir</strong> (□↑) en la barra inferior.</Paso>
            <Paso n="2" sketch={<Iphone2 />}>Baja y elige <strong>“Agregar a pantalla de inicio”</strong>.</Paso>
            <Paso n="3" sketch={<Iphone3 />}>Toca <strong>Agregar</strong>. Abre Edge Elite desde el ícono nuevo.</Paso>
            <p style={{ fontSize: 12.5, color: 'var(--muted)', margin: '4px 0 0', lineHeight: 1.5 }}>
              Las alertas en el teléfono solo funcionan si abres la app desde el ícono instalado.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
